import { can, type AuthorizedUser } from '@dma/auth';
import { AuthorizationError, ApplicationError, type Logger } from '@dma/shared';
import { InvalidArticleError } from '../../domain/errors/InvalidArticleError';
import type { ArticleRepository } from '../../domain/repositories/ArticleRepository.interface';
import type { ArticleCategory } from '../../domain/entities/Article.entity';
import type { ArticleDto } from '../dto/ArticleDto';

export class GetAdminArticlesUseCase {
  constructor(
    private readonly repository: ArticleRepository,
    private readonly logger: Logger
  ) {}

  public async execute(actingUser: AuthorizedUser | null, category: ArticleCategory): Promise<ArticleDto[]> {
    if (!can(actingUser, 'news:update')) {
      throw new AuthorizationError();
    }

    try {
      const articles = await this.repository.getAllForAdmin(category);
      return articles.map((article) => article.props);
    } catch (error) {
      if (error instanceof InvalidArticleError) {
        this.logger.error('Article content failed domain validation', {
          category,
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('ARTICLES_UNAVAILABLE', 'فهرست مطالب در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }
  }
}
